import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import DetailPage from '@/components/pages/backoffice/_klb-penyuluh/_kotakab/containers/DetailPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/kotakab/$kotakabId/'
)({
  component: DetailPage,
  validateSearch: z.object({
    tab: z.string().optional().default('profile')
  })
})
